import { routerMiddleware as middleware } from 'connected-react-router';
import withDependencies from '@factorin/container.macro';


export const routerMiddleware =
    withDependencies(history => middleware(history));
